var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error.statusCode === 403)?_c('ForbiddenPage'):_c('NotFoundPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }